package com.bikompanion.data

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CityBikesStationDto(
    val id: String,
    val name: String,
    val latitude: Double,
    val longitude: Double,
    @SerialName("free_bikes") val freeBikes: Int = 0,
    @SerialName("empty_slots") val emptySlots: Int? = null,
    val extra: CityBikesStationExtraDto? = null,
)
